export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg
    viewBox="0 0 40 40"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M20 2.5 L34.5 7.6 V19.5 C34.5 28.8 28.4 35.2 20 37.5 C11.6 35.2 5.5 28.8 5.5 19.5 V7.6 Z"
      fill="#0A0A0A"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="20" cy="18.5" r="7.5" stroke="#00F0FF" strokeWidth="2" />
    <circle cx="20" cy="18.5" r="2.6" fill="#00F0FF" />
    <path
      d="M20 11 A7.5 7.5 0 0 1 27.5 18.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ className = "", markClass = "h-8 w-8", textClass = "text-lg" }) => (
  <span className={`flex items-center gap-2.5 ${className}`}>
    <span className="text-cyanbrand">
      <LogoMark className={markClass} />
    </span>
    <span className={`font-display font-semibold tracking-tight leading-none ${textClass}`}>
      SC<span className="text-cyanbrand">·</span>Security
    </span>
  </span>
);
